<template>
  <Dialog
    :open="!closing"
    @update:open="handleUpdateOpen"
    variant="passport"
    background="white"
    :size="maxTablet ? 'full' : undefined"
    :side="maxTablet ? 'default' : 'right'"
    :showFooter="maxTablet"
  >
    <template #header>
      <Header :file="file" :canDelete="canDelete" :canUpdate="canUpdate" />
    </template>
    <template #content>
      <Body :file="file" :canUpdate="canUpdate" />
    </template>
    <template #footer>
      <div
        class="px-6 py-4 bg-primary border-t border-secondary flex justify-center"
      >
        <MediaViewer
          v-if="isSupportedMedia(file.file.mime_type)"
          :title="file.file.name"
          :src="file.file.urls.file"
          :type="file.file.mime_type"
        >
          <Button
            variant="primary"
            size="lg"
            type="filled"
            :label="$t('components.buttons.preview')"
            class="max-w-full min-w-[320px] mx-auto"
          >
            <template #start>
              <Icon name="eye-visible" />
            </template>
          </Button>
        </MediaViewer>
      </div>
    </template>
  </Dialog>
</template>

<script setup>
// Import Vue Utilities
import { ref, inject, computed } from "vue";

// Import Components
import { Button } from "@/SharedComponents/Buttons";
import { Dialog } from "@/SharedComponents/Dialog";
import { Icon } from "@/SharedComponents/Icon";
import { MediaViewer, isSupportedMedia } from "@/SharedComponents/Media";
import { Header, Body } from "@/Pages/Files/Partials/Detail";

// Import Composables
import { useBreakpoints } from "@/Composables/useBreakpoints";

// Emit
const emit = defineEmits(["close"]);

// Breakpoints
const { maxTablet } = useBreakpoints();

// Define Props
const props = defineProps({
  file: { type: Object, required: true },
});

// Refs
const closing = ref(false);

// Permssions
const { hasPermission, permissions } = inject("permissions");

// Computed Props
const canDelete = computed(() =>
  hasPermission(permissions.deleteDocument, props.file.tenant.id)
);

const canUpdate = computed(() =>
  hasPermission(permissions.updateDocument, props.file.tenant.id)
);

// Functions
const handleUpdateOpen = (value) => {
  if (!value) {
    closing.value = true;
    setTimeout(() => (closing.value = false), 400);
    emit("close");
  }
};
</script>
